import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from '@/entities/auth';

type Props = {
  children: ReactNode;
};

export const ProtectedRoute = ({ children }: Props) => {
  const { isAuthenticated } = useAuthState();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
};

export const RedirectIfAuth = ({ children }: Props) => {
  const { isAuthenticated } = useAuthState();
  if (isAuthenticated) return <Navigate to="/parcels" replace />;
  return <>{children}</>;
};
